import {httpClientV2} from "../../../../infrastructure/http";
import {
  TransactionChargeSettings,
  TransactionChargeSettingsRepository,
  ChargeBearer,
} from "../../domain/types";
import {ChargeSettingsMapperV2} from "../mappers/mapper.v2";
import {
  V2GetChargeSettingsApiResponse,
  V2UpsertChargeSettingsApiResponse,
} from "../mappers/mapper.types";

/**
 * v2 API implementation of TransactionChargeSettingsRepository.
 *
 * Endpoints:
 * - GET  payments/charge-settings
 * - POST payments/charge-settings
 *
 * Pure TypeScript - no React imports.
 */
export class ChargeSettingsRepositoryV2 implements TransactionChargeSettingsRepository {
  private readonly endpoint = "payments/charge-settings";

  async getSettings(): Promise<TransactionChargeSettings | null> {
    const response = await httpClientV2.get<V2GetChargeSettingsApiResponse>(
      this.endpoint
    );

    if (!response.data) {
      return null;
    }

    return ChargeSettingsMapperV2.toDomain(response.data);
  }

  async upsertSettings(chargeBearer: ChargeBearer): Promise<TransactionChargeSettings> {
    const payload = ChargeSettingsMapperV2.toApiRequest(chargeBearer);

    const response = await httpClientV2.post<V2UpsertChargeSettingsApiResponse>(
      this.endpoint,
      payload
    );

    return ChargeSettingsMapperV2.toDomain(response.data);
  }
}
